module.exports = __webpack_public_path__ + "static/media/ipad-splash.4ff67135.png";